export const MOUNT_SELECTOR = '.vue-club-info-modal-mount'

export const CLUB_CARD_INFO = [
  {
    title: 'Как работает клубная карта',
    sentences: [
      'Карта даёт вам цену ниже на 30% на приёмы врачей.',
      'Для этого вы оплачиваете невозвратный купон на сайте за половину стоимости приёма.',
      'Вторую половину оплачиваете уже на месте, когда приходите в клинику.',
    ],
  },
  {
    title: 'Карта действует полгода',
    sentences: [
      'Первая карта – в подарок при покупке невозвратного купона на сайте.',
      `Следующую можно будет купить за 99 ${window.CURRENCY_DATA.symbol}.`,
    ],
  },
  {
    title: 'Отдельно про услуги',
    sentences: [
      'В некоторых случаях врач не просто проводит консультацию,',
      'но и оказывает дополнительные услуги: взятие мазка, биопсия, инъекция и т.д.',
      'Цена даётся только на приём. Услуги на приёме оплачиваются отдельно.',
    ],
  },
]

export const CLUB_CARD_FAQ = [
  {
    title: 'Можно ли пойти на приём по клубной цене без\u00A0оплаты на сайте?',
    sentences: [
      'Клубная цена на приём действует только при наличии невозвратного купона.',
      'Если вы не приобрели купон на сайте, вам нужно будет оплатить в клинике приём по обычной стоимости.',
    ],
  },
  {
    title: 'Записываться по клубной цене можно ко всем врачам?',
    sentences: [
      'Только к тем, у которых возле стоимости приёма стоит метка клуба.',
      'Если метки нет, значит клиника не вступила в клуб и записаться по клубной цене не получится.',
    ],
  },
  {
    title: 'Можно вернуть оплату, если я не смогу пойти на приём?',
    sentences: [
      'Оплата не возвращается. Вы можете связаться с клиникой и договориться перенести приём.',
      'Если вам пойдут навстречу, оплата сохранится.',
    ],
  },
  {
    title: 'Как я докажу в клинике, что приём уже наполовину оплачен?',
    sentences: [
      'Обычно в клинике уже знают об этом.',
      'Но чтобы точно не было трудностей, покажите администратору невозвратный купон.',
      'Его можно скачать после оплаты. Мы также отправим его вам на почту.',
    ],
  },
]

export const CLUB_SERVICE_PRICE_INFO = [
  {
    isOrderedListElement: false,
    title: 'Как работает',
    sentences: [
      'Действует на все услуги клиники, включая те, которых нет на ПроДокторов.',
      'Не распространяется на приём врача.',
      'Суммируется со всеми акциями. Например, если в клинике акция «Скидка 5% на КТ лёгких», то пациент в клубе получит цену ниже на 15%.',
    ],
  },
  {
    isOrderedListElement: true,
    title: 'Как пойти по клубной цене, если вы уже в клубе',
    sentences: [
      'Запишитесь на услугу любым способом.',
      `В день оказания услуги покажите администратору клиники
            <button
                class="primary--text text-decoration-none"
                data-open-club-card
            >
                карту клуба
            </button>
            в своём профиле.`,
    ],
  },
]
